import { safeApiRequest } from './apiClient';

/** API gövdesinden duyuru listesini güvenli çöz (alan adı / id biçimi farklarına tolerans). */
export const parseAdminAnnouncementsResult = (res) => {
  const payload = res && typeof res === 'object' ? res : {};
  const veri = payload.veri != null ? payload.veri : payload;
  const raw = veri?.duyurular ?? veri?.items ?? [];
  const duyurular = Array.isArray(raw)
    ? raw
        .map((d) => ({
          ...d,
          id: d?.id != null ? String(d.id) : d?._id != null ? String(d._id) : '',
        }))
        .filter((d) => d.id)
    : [];
  const p = veri?.sayfalama || {};
  return {
    duyurular,
    sayfalama: {
      toplamKayit: p.toplamKayit ?? 0,
      sayfa: p.sayfa ?? 1,
      limit: p.limit ?? 25,
      toplamSayfa: Math.max(1, p.toplamSayfa ?? 1),
    },
  };
};

export const parseInboxAnnouncementsResult = (res) => {
  const payload = res && typeof res === 'object' ? res : {};
  const veri = payload.veri != null ? payload.veri : payload;
  const raw = veri?.duyurular ?? veri?.items ?? [];
  const duyurular = Array.isArray(raw)
    ? raw
        .map((d) => ({
          ...d,
          id: d?.id != null ? String(d.id) : d?._id != null ? String(d._id) : '',
        }))
        .filter((d) => d.id)
    : [];
  const p = veri?.sayfalama || {};
  return {
    duyurular,
    sayfalama: {
      toplamKayit: p.toplamKayit ?? 0,
      sayfa: p.sayfa ?? 1,
      limit: p.limit ?? 25,
      toplamSayfa: Math.max(1, p.toplamSayfa ?? 1),
    },
  };
};

const ADMIN_GROUPS = '/api/admin/announcement-groups';
const ADMIN_ANN = '/api/admin/announcements';
const INBOX_BASE = '/api/announcements';

export const fetchAnnouncementGroups = async () => {
  const res = await safeApiRequest(ADMIN_GROUPS, { method: 'GET', skipCsrf: true });
  return res?.veri?.gruplar || [];
};

export const createAnnouncementGroup = async ({ ad, uyeler }) => {
  return safeApiRequest(ADMIN_GROUPS, {
    method: 'POST',
    body: { ad, uyeler: uyeler || [] },
  });
};

export const updateAnnouncementGroup = async (id, { ad, uyeler }) => {
  return safeApiRequest(`${ADMIN_GROUPS}/${id}`, {
    method: 'PATCH',
    body: { ad, uyeler },
  });
};

export const deleteAnnouncementGroup = async (id) => {
  return safeApiRequest(`${ADMIN_GROUPS}/${id}`, {
    method: 'DELETE',
  });
};

export const fetchAdminAnnouncements = async ({ sayfa = 1, limit = 25, arsiv } = {}) => {
  const query = { sayfa, limit };
  if (arsiv === true) query.arsiv = 'true';
  return safeApiRequest(ADMIN_ANN, {
    method: 'GET',
    query,
    skipCsrf: true,
  });
};

export const createAnnouncement = async (body) => {
  return safeApiRequest(ADMIN_ANN, {
    method: 'POST',
    body,
  });
};

export const fetchAdminAnnouncementDetail = async (id) => {
  return safeApiRequest(`${ADMIN_ANN}/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/** TP / MA gelen kutusu */
export const fetchInboxAnnouncements = async ({ sayfa = 1, limit = 25 } = {}) => {
  return safeApiRequest(`${INBOX_BASE}/inbox`, {
    method: 'GET',
    query: { sayfa, limit },
    skipCsrf: true,
  });
};

export const fetchInboxAnnouncementDetail = async (id) => {
  return safeApiRequest(`${INBOX_BASE}/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

export const markAnnouncementRead = async (id) => {
  return safeApiRequest(`${INBOX_BASE}/${id}/read`, {
    method: 'POST',
    body: {},
  });
};
